// ────────────────────────────────────────────────────────────────────
// RevBadge — small "Rev.N" chip shown everywhere a file appears (workbench
// roadmap B2). A superseded copy gets an additional muted "ถูกแทนที่" marker,
// but ONLY when the caller explicitly opts in via `showSuperseded` — staff
// contexts (DeliveryCard, the documents table) pass it; customer-visible
// surfaces don't, because a customer should never be looking at a superseded
// copy in the first place (server-side enforced — see GET /api/intake's
// current_only rule). The Rev number itself is harmless to show anywhere:
// it doesn't reveal whether a newer revision exists.
// ────────────────────────────────────────────────────────────────────
export function RevBadge({ revision, isCurrent = true, showSuperseded = false }: {
  revision?: string | null;
  isCurrent?: boolean;
  showSuperseded?: boolean;
}): JSX.Element | null {
  if (!revision) return null;
  return (
    <span className="inline-flex items-center gap-1 shrink-0">
      <span className="font-mono uppercase" data-testid="rev-badge"
            style={{ fontSize: 9, letterSpacing: ".04em", color: "var(--ink-3)",
                     background: "var(--paper)", border: "1px solid var(--hairline)",
                     padding: "1px 4px", borderRadius: 3, lineHeight: 1.5 }}>
        Rev.{revision}
      </span>
      {showSuperseded && !isCurrent && (
        <span className="font-mono uppercase" data-testid="superseded-marker"
              style={{ fontSize: 8.5, letterSpacing: ".04em", color: "var(--warn)",
                       background: "rgba(180,83,9,0.10)", padding: "1px 4px",
                       borderRadius: 3, lineHeight: 1.5 }}>
          ถูกแทนที่
        </span>
      )}
    </span>
  );
}
